"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var WhatsAppSettings_1;
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsAppSettings = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const component_1 = require("@front/layouts/default-layout/component");
const qrcode_1 = __importDefault(require("qrcode"));
require("@front/components/app-loader/component");
require("@front/components/pop3-settings/component");
require("@front/components/form-parts/tags/component");
require("@front/components/comms-threads-list/component");
const WhatsAppAgentService_1 = __importStar(require("@front/services/WhatsAppAgentService"));
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const component_2 = require("@front/components/form-parts/form/component");
const component_3 = require("@front/components/site-menu/component");
// Strips ANSI/chalk colour codes and resets from a string
function stripAnsi(str) {
    // eslint-disable-next-line no-control-regex
    return str.replace(/\x1B\[[0-9;]*[mGKHF]/g, '').replace(/\x1B\[[0-9]*[A-Za-z]/g, '');
}
//@ts-ignore                
let rwsTemplate = T.html `<div id="settings-whatsapp-page" class="container-fluid">
    <div class="page-header">
        <h1>${'whatsapp.settings.title'.t()}</h1>
        <div class="d-flex flex-row justify-content-between align-items-center">            
            <h2>${x => x.form.phoneNumber ? `${x.form.phoneNumber}` : ''}${x => x.form.title ? ` (${x.form.title})` : ''}</h2>
            <div class="text-small mb-2">${'whatsapp.settings.creator'.t()}: <strong>${x => x.form.creator}</strong></div>        
        </div>
    </div>

    <div class="mb-4">
        <div class="row">

            <div class="col-sm-2">
                ${(0, fast_element_1.when)(x => !x.agentActive && !x.agentInitializing && !x.agentStarting, (0, fast_element_1.html) `
                <button class="btn btn-success" @click="${x => x.startAgent()}"
                    ?disabled="${x => x.agentStarting || !x.form.phoneNumber || x.agentInitializing || x.agentChecking || x.agentStarting}">
                    ${(0, fast_element_1.when)(x => x.agentStarting, (0, fast_element_1.html) `
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    `)}
                    <i class="simple-icon-control-play mr-1"></i>
                    ${'whatsapp.settings.startAgent'.t()}
                </button>
                `)}

                ${(0, fast_element_1.when)(x => x.agentActive || x.agentInitializing || x.agentStarting, (0, fast_element_1.html) `
                <button class="btn btn-danger" @click="${x => x.stopAgent()}"
                    ?disabled="${x => x.agentStopping || !x.form.phoneNumber || x.agentInitializing || x.agentChecking || x.agentStarting}">
                    ${(0, fast_element_1.when)(x => x.agentStopping, (0, fast_element_1.html) `
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    `)}
                    <i class="simple-icon-control-pause mr-1"></i>
                    ${'whatsapp.settings.stopAgent'.t()}
                </button>
                `)}
            </div>
            <div class="col-sm-1">
                <div class="mt-2">
                    <span
                        class="badge bg-${x => x.agentActive ? 'success' : (x.agentChecking || x.agentInitializing || x.agentStarting) ? 'warning' : 'danger'} text-dark">
                        <i class="simple-icon-bulb mr-1"></i>
                        ${x => `whatsapp.settings.agent_status_${x.agentActive ? 'active' : (x.agentChecking ||
    x.agentInitializing || x.agentStarting) ? 'initializing' : 'inactive'}`.t()}
                    </span>
                </div>
            </div>

            <div class="${x => x.gated ? 'ml-auto col-5' : 'ml-auto col-5'}">
                <div class="row mb-3">
                    <div class="${x => x.gated ? 'col-12' : 'col-8'}">
                        <part-select label="whatsapp.groups.selectNumber"
                            placeholder="whatsapp.groups.selectNumberPlaceholder" :value="${x => x.selectedSettingsId}"
                            :options="${x => x.settingsOptions}" :onChange="${x => x.onSettingsSelectChange.bind(x)}">
                        </part-select>
                    </div>
                    ${(0, fast_element_1.when)(x => !x.gated, (0, fast_element_1.html) `
                    <div class="col-4">
                        <button type="button" class="btn btn-outline-primary btn-sm"
                            @click="${x => x.goToCreateNumber()}">
                            <i class="simple-icon-plus mr-1"></i>${'route.settings.whatsappSettings.create'.t()}
                        </button>
                    </div>
                    `)}
                </div>
            </div>
        </div>
    </div>    

    ${(0, fast_element_1.when)(x => x.selectedSettingsId, (0, fast_element_1.html) `
        <ul class="nav nav-tabs mb-4">
            <li class="nav-item">
                <button class="nav-link ${x => x.activeTab === 'threads' ? 'active' : ''}"
                    @click="${x => x.switchTab('threads')}">
                    ${'whatsapp.tabs.threads'.t()}
                </button>
            </li>
            <li class="nav-item">
                <button class="nav-link ${x => x.activeTab === 'groups' ? 'active' : ''}"
                    @click="${x => x.switchTab('groups')}">
                    ${'whatsapp.tabs.groups'.t()}
                </button>
            </li>
            <li class="nav-item">
                <button class="nav-link ${x => x.activeTab === 'directMessages' ? 'active' : ''}"
                    @click="${x => x.switchTab('directMessages')}">
                    ${'whatsapp.tabs.directMessages'.t()}
                </button>
            </li>
            <li class="nav-item">
                <button class="nav-link ${x => x.activeTab === 'email' ? 'active' : ''}"
                    @click="${x => x.switchTab('email')}">
                    ${'whatsapp.tabs.email'.t()}
                </button>
            </li>
            <li class="ml-auto nav-item">
                <button class="nav-link ${x => x.activeTab === 'emailSettings' ? 'active' : ''}"
                    @click="${x => x.switchTab('emailSettings')}">
                    ${'whatsapp.tabs.emailSettings'.t()}
                </button>
            </li>
            ${(0, fast_element_1.when)(x => !x.gated, (0, fast_element_1.html) `
            <li class="nav-item">
                <button class="ml-auto  nav-link ${x => x.activeTab === 'settings' ? 'active' : ''}"
                    @click="${x => x.switchTab('settings')}">
                    ${'whatsapp.tabs.settings'.t()}
                </button>
            </li>
            `)}
        </ul>

        ${(0, fast_element_1.when)(x => x.activeTab === 'threads', (0, fast_element_1.html) `
        <comms-threads-list :settingsId="${x => x.settingsId}" phoneNumber="${x => x.form.phoneNumber}"
            @track-log-go-to-source="${(x, c) => x.handleTrackLogGoToSource(c.event)}"></comms-threads-list>
        `)}

        ${(0, fast_element_1.when)(x => x.activeTab === 'groups', (0, fast_element_1.html) `
        <wa-group-list :settingsId="${x => x.settingsId}" phoneNumber="${x => x.form.phoneNumber}"
            :phoneNumbers="${x => x.phoneNumbersList}" :agentActive="${x => x.agentActive}"></wa-group-list>
        `)}

        ${(0, fast_element_1.when)(x => x.activeTab === 'directMessages', (0, fast_element_1.html) `
        <wa-group-list mode="directMessages" :settingsId="${x => x.settingsId}" phoneNumber="${x => x.form.phoneNumber}"
            :phoneNumbers="${x => x.phoneNumbersList}"></wa-group-list>
        `)}

        ${(0, fast_element_1.when)(x => x.activeTab === 'email', (0, fast_element_1.html) `
        <wa-group-list mode="email" :settingsId="${x => x.settingsId}" phoneNumber="${x => x.form.phoneNumber}"
            :phoneNumbers="${x => x.phoneNumbersList}"></wa-group-list>
        `)}

        ${(0, fast_element_1.when)(x => x.activeTab === 'emailSettings', (0, fast_element_1.html) `
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pt-2 d-flex justify-content-between align-items-center">
                        <div>
                            <h5 class="card-title">
                                ${'whatsapp.settings.pop3.title'.t()}
                            </h5>
                            <p class="text-muted mb-0">${'whatsapp.settings.pop3.description'.t()}</p>
                        </div>
                        <button class="btn btn-primary btn-sm" @click="${x => x.openEmailModal()}">
                            <i class="simple-icon-settings mr-1"></i>
                            ${'whatsapp.settings.pop3.configure'.t()}
                        </button>
                    </div>
                    <div class="card-body">
                        ${(0, fast_element_1.when)(x => !x.pop3Settings || x.pop3Settings.length === 0, (0, fast_element_1.html) `
                        <div class="alert alert-info mb-0">
                            <i class="simple-icon-info mr-2"></i>${'whatsapp.settings.pop3.empty'.t()}
                        </div>
                        `)}
                        ${(0, fast_element_1.when)(x => x.pop3Settings && x.pop3Settings.length > 0, (0, fast_element_1.html) `
                        <div class="table-responsive">
                            <table class="table table-sm table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>${'whatsapp.settings.pop3.host.label'.t()}</th>
                                        <th>${'whatsapp.settings.pop3.username.label'.t()}</th>
                                        <th class="text-center">${'whatsapp.settings.pop3.useTls.label'.t()}</th>
                                        <th class="text-center">${'whatsapp.settings.pop3.enabled.label'.t()}</th>
                                        <th class="text-center">${'whatsapp.settings.pop3.actions'.t()}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${(0, fast_element_1.repeat)(x => x.pop3Settings || [], (0, fast_element_1.html) `
                                    <tr>
                                        <td>${entry => entry.host || '-'}</td>
                                        <td>${entry => entry.username || '-'}</td>
                                        <td class="text-center">
                                            <span
                                                class="badge bg-${entry => entry.useTls !== false ? 'success' : 'secondary'}">
                                                ${entry => entry.useTls !== false ? 'TLS' : 'No TLS'}
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <span
                                                class="badge bg-${entry => entry.enabled !== false ? 'success' : 'danger'}">
                                                ${entry => entry.enabled !== false ?
    'whatsapp.settings.pop3.enabled.yes'.t() :
    'whatsapp.settings.pop3.enabled.no'.t()}
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <button class="btn btn-sm btn-outline-danger"
                                                @click="${(entry, c) => c.parent.removePop3Entry(c.event, entry)}"
                                                title="${'whatsapp.settings.pop3.remove'.t()}">
                                                <i class="simple-icon-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    `)}
                                </tbody>
                            </table>
                        </div>
                        `)}
                    </div>
                </div>
            </div>
        </div>
        `)}

        ${(0, fast_element_1.when)(x => x.activeTab === 'settings', (0, fast_element_1.html) `
        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
        <app-loader></app-loader>
        `)}

        ${(0, fast_element_1.when)(x => !x.loading, (0, fast_element_1.html) `
        <div class="mb-3">
            <h2 class="mb-0">${'whatsapp.settings.formTitle'.t()}</h2>
        </div>
        <div class="row">
            
            <div class="col-md-6">
                <div class="card mb-4 ">
                    <div class="card-header pt-2">
                        <h5 class="card-title">
                            ${'whatsapp.settings.phoneTitle'.t()}
                        </h5>
                        <p class="text-muted">${'whatsapp.settings.description'.t()}</p>

                    </div>
                    <div class="card-body">
                        <the-form :onSubmit="${(x, c) => x.saveSettings.bind(x)}">
                            <div class="mb-3">
                                <part-input class="form-part" label="${'whatsapp.settings.titleLabel'.t()}"
                                    :value="${x => x.form.title}" name="title"
                                    placeholder="${'whatsapp.settings.titlePlaceholder'.t()}"></part-input>
                            </div>                           
                            <div class="mb-3">
                                <part-input class="form-part" mask="${x => x.phoneMask}" required="true"
                                    label="${'whatsapp.settings.phoneLabel'.t()}" :value="${x => x.form.phoneNumber}"
                                    name="phoneNumber" placeholder="+48 XXX XXX XXX"></part-input>
                                <div class="form-text">${'whatsapp.settings.phoneHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-select class="form-part" label="${'whatsapp.settings.communicationTypeLabel'.t()}"
                                    :value="${x => x.form.communicationType}" name="communicationType"
                                    :options="${x => x.communicationTypeOptions}"></part-select>
                                <div class="form-text">${'whatsapp.settings.communicationTypeHint'.t()}</div>
                            </div>
                            ${(0, fast_element_1.when)(x => x.form.communicationType === 'TELE', (0, fast_element_1.html) `
                            <div class="mb-3">
                                <a href="https://my.telegram.org/apps" target="_blank" rel="noopener noreferrer">
                                    ${'whatsapp.settings.telegramApiLink'.t()}
                                </a>
                            </div>
                            <div class="mb-3">
                                <part-input class="form-part" label="${'whatsapp.settings.apiIdLabel'.t()}"
                                    :value="${x => x.form.apiId}" name="apiId"
                                    placeholder="${'whatsapp.settings.apiIdPlaceholder'.t()}"></part-input>
                                <div class="form-text">${'whatsapp.settings.apiIdHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-input class="form-part" label="${'whatsapp.settings.apiHashLabel'.t()}"
                                    :value="${x => x.form.apiHash}" name="apiHash"
                                    placeholder="${'whatsapp.settings.apiHashPlaceholder'.t()}"></part-input>
                                <div class="form-text">${'whatsapp.settings.apiHashHint'.t()}</div>
                            </div>
                            `)}
                            <div class="mb-3">
                                <part-tags class="form-part" label="${'whatsapp.settings.reportEmailLabel'.t()}"
                                    :value="${x => x.form.reportEmail}" name="reportEmail"
                                    placeholder="${'whatsapp.settings.reportEmailPlaceholder'.t()}"
                                    badgeStyle="info"></part-tags>
                                <div class="form-text">${'whatsapp.settings.reportEmailHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-select class="form-part" label="${'whatsapp.settings.languageLabel'.t()}"
                                    :value="${x => x.form.language}" name="language" :options="${x => [
    { label: 'lang.pl', value: 'pl' },
    { label: 'lang.en', value: 'en' },
    { label: 'lang.de', value: 'de' },
    { label: 'lang.es', value: 'es' },
    { label: 'lang.it', value: 'it' },
    { label: 'lang.zh', value: 'zh' }
]}"></part-select>
                                <div class="form-text">${'whatsapp.settings.languageHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-select class="form-part" label="${'whatsapp.settings.avatarLabel'.t()}"
                                    :value="${x => x.form.avatarId}" name="avatarId"
                                    :options="${x => [{ label: 'whatsapp.settings.selectAvatar'.t(), value: '' }, ...x.availableAvatars.map(a => ({ label: a.name, value: a.id }))]}"></part-select>
                                <div class="form-text">${'whatsapp.settings.avatarHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-textarea class="form-part"
                                    label="${'whatsapp.settings.botResponseConditionLabel'.t()}"
                                    :value="${x => x.form.botResponseCondition}" name="botResponseCondition"
                                    placeholder="${'whatsapp.settings.botResponseConditionPlaceholder'.t()}"></part-textarea>
                                <div class="form-text">${'whatsapp.settings.botResponseConditionHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-textarea class="form-part" label="${'whatsapp.settings.pinMessageLabel'.t()}"
                                    :value="${x => x.form.pinMessage}" name="pinMessage" rows="4"
                                    placeholder="${'whatsapp.settings.pinMessagePlaceholder'.t()}"></part-textarea>
                                <div class="form-text">${'whatsapp.settings.pinMessageHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-switch class="form-part" label="${'whatsapp.settings.pingerLabel'.t()}"
                                    :value="${x => x.form.pinger}" name="pinger"></part-switch>
                                <div class="form-text">${'whatsapp.settings.pingerHint'.t()}</div>
                            </div>
                            ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `
                            <div class="mb-3">
                                <label class="form-label">${'whatsapp.settings.systemCommunicationGroupLabel'.t()}</label>
                                <v-select class="form-part" :value="${x => x.form.systemCommunicationGroupId}"
                                    name="systemCommunicationGroupId"
                                    :choiceList="${x => x.availableGroups.map(group => ({ label: group.groupName || group.phoneNumber, value: String(group.id) }))}"
                                    placeholder="${'whatsapp.settings.selectGroup'.t()}"
                                    @change="${(x, c) => x.handleSystemCommunicationGroupChange(c.event)}"></v-select>
                                <div class="form-text">${'whatsapp.settings.systemCommunicationGroupHint'.t()}</div>
                            </div>
                            <div class="mb-3">
                                <part-switch class="form-part" label="${'whatsapp.settings.systemCommunicationLabel'.t()}"
                                    :value="${x => x.form.systemCommunication}" name="systemCommunication"></part-switch>
                                <div class="form-text">${'whatsapp.settings.systemCommunicationHint'.t()}</div>
                            </div>
                            `)}
                            <div class="d-flex gap-2">
                                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary"
                                    ?disabled="${x => x.saving || !x.form.phoneNumber}">
                                    ${(0, fast_element_1.when)(x => x.saving, (0, fast_element_1.html) `
                                    <span class="spinner-border spinner-border-sm me-1"></span>
                                    `)}
                                    <i class="simple-icon-check mr-1"></i>
                                    ${'whatsapp.settings.save'.t()}
                                </button>
                            </div>
                        </the-form>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">
                            <i class="simple-icon-note"></i>
                            ${'whatsapp.settings.logsTitle'.t()}
                        </h5>
                        <button class="btn btn-sm btn-outline-secondary" @click="${x => x.clearLogs()}">
                            <i class="simple-icon-trash mr-1"></i>
                            ${'whatsapp.settings.clearLogs'.t()}
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="log-container">
                            ${(0, fast_element_1.when)(x => x.logs.length === 0, (0, fast_element_1.html) `
                            <p class="text-muted text-center">${'whatsapp.settings.noLogs'.t()}</p>
                            `)}
                            ${(0, fast_element_1.repeat)(x => x.logs, (0, fast_element_1.html) `
                            <div class="log-entry log-${x => x.level}">
                                <span class="log-time">${x => new Date(x.timestamp).toLocaleTimeString()}</span>
                                <span
                                    class="log-level badge bg-${x => x.level === 'error' ? 'danger' : x.level === 'warn' ? 'warning' : 'info'}">${x => (x.level || 'info').toUpperCase()}</span>
                                <span class="log-message">${x => x.message}</span>
                            </div>
                            `)}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        `)}
        `)}

        ${(0, fast_element_1.when)(x => x.qrCode || x.telegramAwaitingCode || x.telegramAwaitingPassword, (0, fast_element_1.html) `
        <rws-modal :closeModal="${x => x.closeQrModal.bind(x)}">
            <div class="card mb-4">
                <div class="card-header">
                    <h5 class="card-title">
                        ${(0, fast_element_1.when)(x => x.communicationType === 'TELE', (0, fast_element_1.html) `
                        <i class="simple-icon-paper-plane"></i>
                        ${'whatsapp.settings.telegramAuthTitle'.t()}
                        `)}
                        ${(0, fast_element_1.when)(x => x.communicationType !== 'TELE', (0, fast_element_1.html) `
                        <i class="simple-icon-magnifier"></i>
                        ${'whatsapp.settings.qrTitle'.t()}
                        `)}
                    </h5>
                </div>
                <div class="card-body text-center">
                    ${(0, fast_element_1.when)(x => x.communicationType !== 'TELE' && x.qrCode, (0, fast_element_1.html) `
                    <p class="text-muted mb-3">${'whatsapp.settings.qrInstruction'.t()}</p>
                    <div class="qr-code-container">
                        <img :src="${x => x.qrDataUrl}" alt="WhatsApp QR Code" class="qr-code-image" />
                    </div>
                    `)}

                    ${(0, fast_element_1.when)(x => x.communicationType === 'TELE' && x.telegramAwaitingCode, (0, fast_element_1.html) `
                    <p class="text-muted mb-3">${'whatsapp.settings.telegramCodeInstruction'.t()}</p>
                    <div class="form-group mb-3">
                        <input type="text" class="form-control text-center"
                            style="font-size: 1.5rem; letter-spacing: 0.5rem;" :value="${x => x.telegramCode}"
                            @input="${(x, c) => x.telegramCode = c.event.target.value}"
                            placeholder="${'whatsapp.settings.telegramCodePlaceholder'.t()}" maxlength="6" />
                    </div>
                    <button class="btn btn-primary" @click="${x => x.submitTelegramCode()}">
                        <i class="simple-icon-check mr-1"></i>
                        ${'whatsapp.settings.telegramCodeSubmit'.t()}
                    </button>
                    `)}

                    ${(0, fast_element_1.when)(x => x.communicationType === 'TELE' && x.telegramAwaitingPassword, (0, fast_element_1.html) `
                    <p class="text-muted mb-3">${'whatsapp.settings.telegramPasswordInstruction'.t()}</p>
                    <div class="form-group mb-3">
                        <input type="password" class="form-control text-center" :value="${x => x.telegramPassword}"
                            @input="${(x, c) => x.telegramPassword = c.event.target.value}"
                            placeholder="${'whatsapp.settings.telegramPasswordPlaceholder'.t()}" />
                    </div>
                    <button class="btn btn-primary" @click="${x => x.submitTelegramPassword()}">
                        <i class="simple-icon-check mr-1"></i>
                        ${'whatsapp.settings.telegramPasswordSubmit'.t()}
                    </button>
                    `)}
                </div>
            </div>
        </rws-modal>
        `)}

        ${(0, fast_element_1.when)(x => x.emailModalOpen, (0, fast_element_1.html) `
        <rws-modal header="whatsapp.settings.pop3.title" :closeModal="${x => x.closeEmailModal.bind(x)}">
            <div class="card">
                <div class="card-body">
                    ${(0, fast_element_1.when)(x => x.emailFormEntry.isGmail, (0, fast_element_1.html) `
                    <button class="btn btn-danger" @click="${x => x.connectGmail()}" ?disabled="${x => x.gmailConnecting}">
                        ${(0, fast_element_1.when)(x => x.gmailConnecting, (0, fast_element_1.html) `
                        <span class="spinner-border spinner-border-sm me-1"></span>
                        `)}
                        <i class="simple-icon-envelope mr-1"></i>
                        ${'whatsapp.settings.pop3.gmail.connect'.t()}
                    </button>
                    `, (0, fast_element_1.html) `
                    <pop3-settings :settings="${x => x.pop3Settings}"
                        @pop3-settings-changed="${(x, c) => x.onPop3SettingsChanged(c.event)}"
                        ref="${(0, fast_element_1.ref)('pop3SettingsComponent')}"></pop3-settings>`)}
                    ${(0, fast_element_1.when)(x => !x.emailFormEntry.isGmail, (0, fast_element_1.html) `<div class="d-flex justify-content-end mt-3 gap-2">
                        <button class="btn btn-primary" @click="${x => x.saveEmailSettings()}"
                            ?disabled="${x => x.savingEmail}">
                            ${(0, fast_element_1.when)(x => x.savingEmail, (0, fast_element_1.html) `
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            `)}
                            <i class="simple-icon-check mr-1"></i>
                            ${'whatsapp.settings.pop3.save'.t()}
                        </button>
                    </div>`)}
                </div>
            </div>
        </rws-modal>
        `)}
    </div>
`, (0, fast_element_1.html) `<div class="text-center"><div class="alert alert-info">${'whatsapp.settings.noSettings'.t()}</div></div>`)}
`;
require("./styles/layout.scss");
const styles = T.css `#settings-whatsapp-page .wa-groups-dashboard {
  height: calc(100vh - 380px);
}
#settings-whatsapp-page .page-header h1 {
  color: var(--bs-primary);
  font-weight: 600;
}
#settings-whatsapp-page .card {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
#settings-whatsapp-page .card .card-header {
  background-color: var(--bs-light);
  border-bottom: 1px solid var(--bs-border-color);
}
#settings-whatsapp-page .card .card-header .card-title {
  margin-bottom: 0;
  font-weight: 600;
  color: var(--bs-dark);
}
#settings-whatsapp-page .card .card-header .card-title i {
  margin-right: 0.5rem;
  color: #25D366;
}
#settings-whatsapp-page .status-indicator {
  display: flex;
  align-items: center;
}
#settings-whatsapp-page .qr-code-container {
  padding: 1rem;
  background: white;
  border-radius: 0.5rem;
  display: inline-block;
  border: 2px solid var(--bs-border-color);
}
#settings-whatsapp-page .qr-code-image {
  max-width: 300px;
  height: auto;
  display: block;
}
#settings-whatsapp-page .log-container {
  max-height: 400px;
  overflow-y: auto;
  background: #1e1e1e;
  border-radius: 0.5rem;
  padding: 1rem;
  font-family: "Courier New", monospace;
  font-size: 0.85rem;
}
#settings-whatsapp-page .log-entry {
  padding: 0.25rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}
#settings-whatsapp-page .log-entry.log-error .log-message {
  color: #ff6b6b;
}
#settings-whatsapp-page .log-entry.log-warn .log-message {
  color: #ffd93d;
}
#settings-whatsapp-page .log-entry.log-info .log-message {
  color: #6bcb77;
}
#settings-whatsapp-page .log-time {
  color: #888;
  white-space: nowrap;
  min-width: 80px;
}
#settings-whatsapp-page .log-level {
  font-size: 0.7rem;
  min-width: 50px;
  text-align: center;
}
#settings-whatsapp-page .log-message {
  color: #e0e0e0;
  word-break: break-word;
}
#settings-whatsapp-page .login-form .form-label {
  font-weight: 500;
}`;
const shadowOptions = { "mode": "open" };
let WhatsAppSettings = WhatsAppSettings_1 = class WhatsAppSettings extends client_1.RWSViewComponent {
    constructor(wsService, waAgentService, popupService, storageService) {
        super();
        this.wsService = wsService;
        this.waAgentService = waAgentService;
        this.popupService = popupService;
        this.storageService = storageService;
        this.gated = false;
        this.phoneNumbersList = [];
        this.loading = false;
        this.saving = false;
        this.qrCode = '';
        this.logs = [];
        this.entityId = '';
        this.availableAvatars = [];
        this.agentActive = false;
        this.agentInitializing = false;
        this.agentChecking = false;
        this.agentStarting = false;
        this.agentStopping = false;
        this.activeTab = 'threads';
        this.qrDataUrl = '';
        this.phoneMask = '+99 999 999 999';
        this.communicationType = 'WA';
        this.communicationTypeOptions = [];
        this.telegramCode = '';
        this.telegramPassword = '';
        this.telegramAwaitingCode = false;
        this.telegramAwaitingPassword = false;
        this.isSuperAdmin = false;
        this.availableGroups = [];
        this.pinger = false;
        // Phone number select (moved from groups-list)
        this.settingsList = [];
        this.settingsOptions = [];
        this.selectedSettingsId = null;
        this.currentSettings = null;
        this.pop3Settings = [];
        this.emailModalOpen = false;
        this.savingEmail = false;
        this.emailFormEntry = { host: '', port: 993, username: '', password: '', useTls: true, enabled: true, isGmail: false };
        this.gmailConnecting = false;
        this.commsType = undefined;
        this.pop3SettingsComponent = null;
        this.form = {
            phoneNumber: '',
            title: '',
            creator: '',
            reportEmail: [],
            language: 'pl',
            botResponseCondition: '',
            avatarId: '',
            communicationType: 'WA',
            apiId: '',
            apiHash: '',
            pinger: false,
            systemCommunication: false,
            systemCommunicationGroupId: ''
        };
        this.sendSubmit = component_2.FormComponent.sendSubmitEvent;
        this.qrCanvas = null;
        this._wsUnsubscribers = [];
        this._agentStatusUnsubscribe = null;
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        this.phoneId = Number(this.routeParams.phoneId);
        this.isSuperAdmin = ((_a = component_1.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        const tabParam = new URLSearchParams(window.location.search).get('tab');
        if (tabParam) {
            this.activeTab = tabParam;
        }
        this.communicationTypeOptions = [
            { label: 'whatsapp.settings.communicationType.wa'.t(), value: 'WA' },
            { label: 'whatsapp.settings.communicationType.tele'.t(), value: 'TELE' }
        ];
        this.loading = true;
        await Promise.all([this.loadSettingsList(), this.loadAvatars()]);
        this.loading = false;
        this.setupWebSocketListeners();
        component_2.FormComponent.listenForValuesChange.bind(this)('form');
        setTimeout(() => {
            this.pop3SettingsComponent = this.$('pop3-settings');
            if (this.pop3SettingsComponent && this.pop3Settings) {
                this.pop3SettingsComponent.setData(this.pop3Settings);
            }
        }, 100);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._wsUnsubscribers.forEach(off => off());
        this._wsUnsubscribers = [];
        if (this._agentStatusUnsubscribe) {
            this._agentStatusUnsubscribe();
            this._agentStatusUnsubscribe = null;
        }
    }
    setupWebSocketListeners() {
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', async (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            if (data && data.qr) {
                this.qrCode = data.qr;
                try {
                    this.qrDataUrl = await qrcode_1.default.toDataURL(data.qr, { width: 300, margin: 2 });
                }
                catch (e) {
                    console.error('QR generation failed', e);
                    this.qrDataUrl = '';
                }
            }
        }, 'comms_qr'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            if (data && data.authenticated) {
                this.qrCode = '';
                this.qrDataUrl = '';
                this.telegramAwaitingCode = false;
                this.telegramAwaitingPassword = false;
            }
        }, 'comms_auth'));
        // Telegram code request
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            this.telegramAwaitingCode = true;
            this.telegramAwaitingPassword = false;
            this.notifyService.notify('whatsapp.telegramCodeSent'.t(), 'info');
        }, 'comms_telegram_code_request'));
        // Telegram password request (2FA)
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            this.telegramAwaitingCode = false;
            this.telegramAwaitingPassword = true;
            this.notifyService.notify('whatsapp.telegramPasswordRequired'.t(), 'info');
        }, 'comms_telegram_password_request'));
        // Telegram authentication error (e.g. PHONE_CODE_INVALID)
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            const errorMsg = data.error || (data.errorType === 'password' ? 'whatsapp.telegramPasswordInvalid'.t() : 'whatsapp.telegramCodeInvalid'.t());
            this.popupService.error(errorMsg);
            // Keep the modal open so user can retry
            if (data.errorType === 'password') {
                this.telegramPassword = '';
            }
            else {
                this.telegramCode = '';
            }
        }, 'comms_telegram_error'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data)
                return;
            if (data.entityId && this.entityId && data.entityId !== this.entityId)
                return;
            const logEntry = {
                level: (data.level || 'info'),
                message: stripAnsi(data.message || ''),
                timestamp: data.timestamp || new Date().toISOString()
            };
            this.logs = [...this.logs, logEntry];
            this.scrollLogsToBottom();
        }, 'comms_log'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            if (data.success) {
                this.qrCode = '';
                this.qrDataUrl = '';
                this.waAgentService.setAgentActive(false, String(this.settingsId));
                this.agentActive = false;
            }
            else {
                this.popupService.error(data.error || 'whatsapp.logoutFailed'.t());
            }
        }, 'comms_logged_out'));
        const settingsId = String(this.settingsId);
        this._agentStatusUnsubscribe = this.waAgentService.onStatusChange(settingsId, (active, initializing) => {
            this.agentActive = active;
            this.agentInitializing = initializing;
        });
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            this.agentStarting = false;
            if (data.success) {
                // Agent process started but still syncing — wait for whatsapp_agent_status
                this.agentInitializing = true;
                this.notifyService.notify('whatsapp.agentStarted'.t(), 'info');
            }
            else {
                this.popupService.error(data.error || 'whatsapp.agentStartFailed'.t());
            }
        }, 'comms_agent_started'));
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const { data } = wsResponse;
            if (!data || (data.settingsId && String(data.settingsId) !== String(this.settingsId)))
                return;
            this.agentStopping = false;
            if (data.success) {
                this.waAgentService.setAgentActive(false, String(this.settingsId));
                this.agentActive = false;
                this.notifyService.notify('whatsapp.agentStopped'.t(), 'info');
            }
            else {
                this.popupService.error(data.error || 'whatsapp.agentStopFailed'.t());
            }
        }, 'comms_agent_stopped'));
    }
    /** Lightweight check — only reads in-memory state via WS, never spawns Puppeteer. */
    async requestStatusViaWs() {
        if (!this.settingsId)
            return false;
        const settingsId = String(this.settingsId);
        const active = await this.waAgentService.checkAgentStatus(settingsId);
        const state = this.waAgentService.getPhoneState(settingsId);
        this.agentActive = state.active;
        this.agentInitializing = state.initializing;
        return active;
    }
    async loadSettingsList() {
        try {
            const opts = { queryParams: {} };
            if (this.phoneNumbersList.length > 0) {
                opts.queryParams.phoneNumbers = this.phoneNumbersList.join(',');
            }
            if (this.commsType) {
                opts.queryParams.commsType = this.commsType;
            }
            const response = await this.apiService.back.get('whatsapp.settings.list', opts);
            if (response && response.success && Array.isArray(response.data)) {
                this.settingsList = response.data;
                this.settingsOptions = response.data.map(s => {
                    const typeLabel = s.communicationType === 'TELE' ? 'TELE' : 'WA';
                    const title = s.title ? ` - ${s.title}` : '';
                    return { label: `${s.phoneNumber} (${typeLabel})${title}`, value: s.id };
                });
                // Auto-select from route params, stored value, or first item
                if (!this.selectedSettingsId) {
                    const routePhoneId = Number(this.routeParams.phoneId);
                    const storedId = this.storageService.get(WhatsAppSettings_1.STORAGE_KEY);
                    const storedSettingsId = storedId ? Number(storedId) : null;
                    if (routePhoneId && this.settingsList.find(s => s.id === routePhoneId)) {
                        this.selectedSettingsId = routePhoneId;
                    }
                    else if (storedSettingsId && this.settingsList.find(s => s.id === storedSettingsId)) {
                        this.selectedSettingsId = storedSettingsId;
                    }
                    else if (this.settingsList.length > 0) {
                        this.selectedSettingsId = this.settingsList[0].id;
                    }
                    const selected = this.settingsList.find(s => s.id === this.selectedSettingsId);
                    if (selected) {
                        this.phoneId = selected.id;
                        await this.loadSettings(selected.id);
                    }
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async onSettingsSelectChange(event) {
        const select = event.target;
        const newId = select.value ? Number(select.value) : null;
        if (!newId || newId === this.selectedSettingsId)
            return;
        this.selectedSettingsId = newId;
        this.storageService.set(WhatsAppSettings_1.STORAGE_KEY, String(newId));
        const selected = this.settingsList.find(s => s.id === newId);
        if (selected) {
            this.phoneId = newId;
            await this.loadSettings(newId);
        }
    }
    goToCreateNumber() {
        component_3.SiteMenu.goto.bind(this)('/settings/comms/create');
    }
    async loadSettings(id) {
        var _a, _b;
        const settingsId = id || this.phoneId || this.settingsId;
        try {
            const response = await this.apiService.back.get('whatsapp.settings.getById', { routeParams: { id: String(settingsId) } });
            if (response && response.success && response.data) {
                const d = response.data;
                // Parse comma-separated emails into array
                const reportEmailArray = d.reportEmail
                    ? d.reportEmail.split(',').map(e => e.trim()).filter(Boolean)
                    : [];
                this.form = {
                    phoneNumber: d.phoneNumber || '',
                    title: d.title || '',
                    creator: d.creatorName || '',
                    reportEmail: reportEmailArray,
                    language: d.language || 'pl',
                    botResponseCondition: d.botResponseCondition || '',
                    avatarId: ((_b = (_a = d.avatar) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) || '',
                    communicationType: d.communicationType || 'WA',
                    apiId: d.apiId || '',
                    apiHash: d.apiHash || '',
                    pinger: !!d.pinger,
                    systemCommunication: !!d.systemCommunication,
                    systemCommunicationGroupId: d.systemCommunicationGroupId || ''
                };
                this.communicationType = d.communicationType || 'WA';
                this.settingsId = d.id || this.phoneId;
                this.entityId = d.phoneNumber || '';
                this.currentSettings = d;
                // Load POP3 settings if present in response
                if (d.pop3Settings) {
                    this.pop3Settings = d.pop3Settings;
                }
                // Load groups for system communication selection (super_admin only)
                if (this.isSuperAdmin && this.settingsId && d.phoneNumber) {
                    try {
                        const groupsResponse = await this.apiService.back.get('whatsapp.groups.list', {
                            routeParams: { settingsId: String(this.settingsId) }
                        });
                        if (groupsResponse && groupsResponse.success && Array.isArray(groupsResponse.data)) {
                            this.availableGroups = groupsResponse.data;
                        }
                    }
                    catch (e) {
                        console.error('Failed to load groups for system communication:', e);
                    }
                }
                // Check agent status after loading settings
                if (this.settingsId) {
                    this.agentChecking = true;
                    setTimeout(async () => {
                        await this.requestStatusViaWs();
                        this.agentChecking = false;
                    }, 1500);
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async loadAvatars() {
        try {
            const response = await this.apiService.back.get('avatar.list', {
                queryParams: { per_page: '1000' }
            });
            if (response && response.success && response.data) {
                this.availableAvatars = response.data;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    onPop3SettingsChanged(event) {
        this.emailFormEntry = event.detail.settings;
    }
    async saveSettings() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.form.phoneNumber || this.form.phoneNumber.trim() === '') {
            this.popupService.error('whatsapp.phoneRequired'.t());
            return;
        }
        const currentId = this.phoneId || this.settingsId;
        if (!currentId) {
            this.popupService.error('whatsapp.settingsSaveFailed'.t());
            return;
        }
        this.saving = true;
        try {
            const payload = {
                phoneNumber: this.form.phoneNumber.trim(),
                title: ((_a = this.form.title) === null || _a === void 0 ? void 0 : _a.trim()) || undefined,
                reportEmail: this.form.reportEmail || undefined,
                language: this.form.language || 'pl',
                botResponseCondition: ((_b = this.form.botResponseCondition) === null || _b === void 0 ? void 0 : _b.trim()) || undefined,
                avatarId: (_c = this.form.avatarId) !== null && _c !== void 0 ? _c : '',
                communicationType: this.form.communicationType || 'WA',
                apiId: ((_d = this.form.apiId) === null || _d === void 0 ? void 0 : _d.trim()) || undefined,
                apiHash: ((_e = this.form.apiHash) === null || _e === void 0 ? void 0 : _e.trim()) || undefined,
                pinger: this.form.pinger
            };
            if (this.isSuperAdmin) {
                payload.systemCommunication = this.form.systemCommunication;
                payload.systemCommunicationGroupId = this.form.systemCommunicationGroupId || undefined;
            }
            const response = await this.apiService.back.put('whatsapp.settings.update', payload, { routeParams: { id: String(currentId) } });
            if (response && response.success) {
                this.settingsId = ((_f = response.data) === null || _f === void 0 ? void 0 : _f.id) || currentId;
                this.notifyService.notify('whatsapp.settingsSaved'.t(), 'info');
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.settingsSaveFailed'.t());
            }
        }
        catch (e) {
            console.error(e);
            this.popupService.error('whatsapp.settingsSaveFailed'.t());
        }
        finally {
            this.saving = false;
        }
    }
    openEmailModal() {
        this.emailFormEntry = {
            host: '',
            port: 993,
            username: '',
            password: '',
            useTls: true,
            enabled: true,
            isGmail: false
        };
        this.emailModalOpen = true;
        // Reset the pop3-settings component after modal renders
        setTimeout(() => {
            this.pop3SettingsComponent = this.$('pop3-settings');
            if (this.pop3SettingsComponent) {
                this.pop3SettingsComponent.resetForm();
            }
        }, 100);
    }
    closeEmailModal() {
        this.emailModalOpen = false;
    }
    async connectGmail() {
        const currentId = this.phoneId || this.settingsId;
        console.log({ currentId });
        if (!currentId) {
            this.popupService.error('whatsapp.settingsSaveFailed'.t());
            return;
        }
        this.gmailConnecting = true;
        try {
            const response = await this.apiService.back.post('whatsapp.settings.gmail.auth', {}, { routeParams: { id: String(currentId) } });
            if (response && response.success && (response === null || response === void 0 ? void 0 : response.authUrl)) {
                const popup = window.open(response.authUrl, 'GmailAuth', 'width=500,height=600,scrollbars=yes,resizable=yes');
                // Listen for postMessage from the popup (primary detection method)
                const onMessage = (event) => {
                    var _a, _b;
                    if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === 'gmail-auth-success') {
                        window.removeEventListener('message', onMessage);
                        clearInterval(checkClosed);
                        this.gmailConnecting = false;
                        this.loadSettings().then(() => {
                            if (this.pop3SettingsComponent) {
                                this.pop3SettingsComponent.setData(this.pop3Settings);
                            }
                            this.closeEmailModal();
                            this.notifyService.notify('whatsapp.settings.pop3.gmail.connected'.t(), 'info');
                        });
                    }
                    else if (((_b = event.data) === null || _b === void 0 ? void 0 : _b.type) === 'gmail-auth-error') {
                        window.removeEventListener('message', onMessage);
                        clearInterval(checkClosed);
                        this.gmailConnecting = false;
                        this.popupService.error(event.data.error || 'whatsapp.settings.pop3.gmail.authFailed'.t());
                    }
                };
                window.addEventListener('message', onMessage);
                // Fallback: poll popup.closed (in case postMessage doesn't fire)
                const checkClosed = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(checkClosed);
                        window.removeEventListener('message', onMessage);
                        this.gmailConnecting = false;
                        this.loadSettings().then(() => {
                            if (this.pop3SettingsComponent) {
                                this.pop3SettingsComponent.setData(this.pop3Settings);
                            }
                            this.closeEmailModal();
                            this.notifyService.notify('whatsapp.settings.pop3.gmail.connected'.t(), 'info');
                        });
                    }
                }, 1000);
                this.notifyService.notify('whatsapp.settings.pop3.gmail.authWindowOpened'.t(), 'info');
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.settings.pop3.gmail.authFailed'.t());
                this.gmailConnecting = false;
            }
        }
        catch (e) {
            console.error(e);
            this.popupService.error('whatsapp.settings.pop3.gmail.authFailed'.t());
            this.gmailConnecting = false;
        }
    }
    async saveEmailSettings() {
        var _a;
        const currentId = this.phoneId || this.settingsId;
        if (!currentId) {
            this.popupService.error('whatsapp.settingsSaveFailed'.t());
            return;
        }
        // Get data from the pop3-settings component
        if (this.pop3SettingsComponent) {
            this.emailFormEntry = this.pop3SettingsComponent.getData();
        }
        // Skip host validation for Gmail mode
        if (!this.emailFormEntry.isGmail && (!this.emailFormEntry.host || this.emailFormEntry.host.trim() === '')) {
            this.popupService.error('whatsapp.settings.pop3.host.required'.t());
            return;
        }
        this.savingEmail = true;
        try {
            const payload = {
                pop3Settings: this.emailFormEntry
            };
            const response = await this.apiService.back.put('whatsapp.settings.updateEmail', payload, { routeParams: { id: String(currentId) } });
            if (response && response.success) {
                this.notifyService.notify('whatsapp.settings.pop3.saved'.t(), 'info');
                // Update POP3 settings list from response
                if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.pop3Settings) {
                    this.pop3Settings = response.data.pop3Settings;
                }
                this.closeEmailModal();
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.settingsSaveFailed'.t());
            }
        }
        catch (e) {
            console.error(e);
            this.popupService.error('whatsapp.settingsSaveFailed'.t());
        }
        finally {
            this.savingEmail = false;
        }
    }
    async removePop3Entry(event, entry) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        if (!entry.id) {
            this.popupService.error('whatsapp.settings.pop3.remove.failed'.t());
            return;
        }
        const currentId = this.phoneId || this.settingsId;
        if (!currentId) {
            this.popupService.error('whatsapp.settingsSaveFailed'.t());
            return;
        }
        const confirmed = await this.popupService.confirm('whatsapp.settings.pop3.remove.confirm'.t());
        if (!confirmed) {
            return;
        }
        try {
            const response = await this.apiService.back.delete('whatsapp.settings.deleteEmail', { routeParams: { id: String(entry.id) } });
            if (response && response.success) {
                this.notifyService.notify('whatsapp.settings.pop3.removed'.t(), 'info');
                // Update POP3 settings list from response
                if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.pop3Settings) {
                    this.pop3Settings = response.data.pop3Settings;
                }
                else {
                    // Remove from local array if not returned from backend
                    this.pop3Settings = this.pop3Settings.filter(p => p.id !== entry.id);
                }
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.settings.pop3.remove.failed'.t());
            }
        }
        catch (e) {
            console.error(e);
            this.popupService.error('whatsapp.settings.pop3.remove.failed'.t());
        }
    }
    startAgent() {
        if (!this.settingsId) {
            this.popupService.error('whatsapp.settingsRequired'.t());
            return;
        }
        this.agentStarting = true;
        const payload = {
            settingsId: this.settingsId
        };
        this.wsService.sendMessage('comms_point', 'comms_start_agent', payload);
    }
    async stopAgent() {
        if (!this.settingsId) {
            this.popupService.error('whatsapp.settingsRequired'.t());
            return;
        }
        this.agentStopping = true;
        try {
            const response = await this.apiService.back.post('whatsapp.stopAgent', { settingsId: this.settingsId });
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.waAgentService.setAgentActive(false, String(this.settingsId));
                this.agentActive = false;
                this.notifyService.notify('whatsapp.agentStopped'.t(), 'info');
            }
            else {
                this.popupService.error((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.agentStopFailed'.t());
            }
        }
        catch (e) {
            console.error(e);
            this.popupService.error('whatsapp.agentStopFailed'.t());
        }
        finally {
            this.agentStopping = false;
        }
    }
    handleSystemCommunicationGroupChange(event) {
        var _a;
        const value = ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.value) || '';
        this.form = { ...this.form, systemCommunicationGroupId: value };
    }
    clearLogs() {
        this.logs = [];
    }
    closeQrModal() {
        this.qrCode = '';
        this.qrDataUrl = '';
        this.telegramAwaitingCode = false;
        this.telegramAwaitingPassword = false;
        this.telegramCode = '';
        this.telegramPassword = '';
    }
    submitTelegramCode() {
        if (!this.telegramCode || this.telegramCode.trim() === '') {
            this.popupService.error('whatsapp.telegramCodeRequired'.t());
            return;
        }
        const payload = {
            settingsId: this.settingsId,
            code: this.telegramCode.trim()
        };
        this.wsService.sendMessage('comms_point', 'comms_telegram_code_submit', payload);
        this.telegramCode = '';
    }
    submitTelegramPassword() {
        if (!this.telegramPassword || this.telegramPassword.trim() === '') {
            this.popupService.error('whatsapp.telegramPasswordRequired'.t());
            return;
        }
        const payload = {
            settingsId: this.settingsId,
            password: this.telegramPassword.trim()
        };
        this.wsService.sendMessage('comms_point', 'comms_telegram_password_submit', payload);
        this.telegramPassword = '';
    }
    handleTrackLogGoToSource(event) {
        const { commsType } = event.detail || {};
        if (commsType === 'EMAIL') {
            this.switchTab('email');
        }
    }
    switchTab(tab) {
        this.activeTab = tab;
        // Sync POP3 settings component when switching to emailSettings tab
        if (tab === 'emailSettings') {
            setTimeout(() => {
                this.pop3SettingsComponent = this.$('pop3-settings');
                if (this.pop3SettingsComponent && this.pop3Settings) {
                    this.pop3SettingsComponent.setData(this.pop3Settings);
                }
            }, 50);
        }
    }
    scrollLogsToBottom() {
        requestAnimationFrame(() => {
            const logContainer = this.$('.log-container');
            if (logContainer) {
                logContainer.scrollTop = logContainer.scrollHeight;
            }
        });
    }
};
exports.WhatsAppSettings = WhatsAppSettings;
WhatsAppSettings.STORAGE_KEY = 'whatsapp_selected_settings_id';
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "gated", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettings.prototype, "phoneNumbersList", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "saving", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "qrCode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettings.prototype, "logs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WhatsAppSettings.prototype, "settingsId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WhatsAppSettings.prototype, "phoneId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettings.prototype, "availableAvatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "agentActive", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "agentInitializing", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "agentChecking", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "agentStarting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "agentStopping", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "activeTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "qrDataUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "phoneMask", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "communicationType", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof Array !== "undefined" && Array) === "function" ? _e : Object)
], WhatsAppSettings.prototype, "communicationTypeOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "telegramCode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "telegramPassword", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "telegramAwaitingCode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "telegramAwaitingPassword", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "isSuperAdmin", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettings.prototype, "availableGroups", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "pinger", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettings.prototype, "settingsList", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof Array !== "undefined" && Array) === "function" ? _f : Object)
], WhatsAppSettings.prototype, "settingsOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WhatsAppSettings.prototype, "selectedSettingsId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof backendImport_1.ICommsSettings !== "undefined" && backendImport_1.ICommsSettings) === "function" ? _g : Object)
], WhatsAppSettings.prototype, "currentSettings", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppSettings.prototype, "pop3Settings", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "emailModalOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "savingEmail", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof backendImport_1.ICommsPop3Settings !== "undefined" && backendImport_1.ICommsPop3Settings) === "function" ? _h : Object)
], WhatsAppSettings.prototype, "emailFormEntry", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppSettings.prototype, "gmailConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppSettings.prototype, "commsType", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WhatsAppSettings.prototype, "form", void 0);
exports.WhatsAppSettings = WhatsAppSettings = WhatsAppSettings_1 = __decorate([
    (0, client_1.RWSView)('settings-whatsapp', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __param(1, (0, client_1.RWSInject)(WhatsAppAgentService_1.default)),
    __param(2, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(3, (0, client_1.RWSInject)(StorageService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WhatsAppAgentService_1.WhatsAppAgentServiceInstance !== "undefined" && WhatsAppAgentService_1.WhatsAppAgentServiceInstance) === "function" ? _b : Object, typeof (_c = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _c : Object, typeof (_d = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _d : Object])
], WhatsAppSettings);
WhatsAppSettings.defineComponent();
